export interface AboutInfo {
  brandName: string;
  brandIntro: string;
  mission: string;
  vision: string;
  history: {
    year: string;
    event: string;
    description: string;
  }[];
  features: {
    icon: string;
    title: string;
    description: string;
  }[];
  testimonials: {
    name: string;
    avatar: string;
    content: string;
    rating: number;
    date: string;
  }[];
  contact: {
    email: string;
    phone: string;
    address: string;
    wechat: string;
    qq: string;
  };
  faqs: {
    question: string;
    answer: string;
  }[];
}

export const aboutData: AboutInfo = {
  brandName: "久久视频",
  brandIntro: "久久视频成立于2020年，是国内领先的视频资源聚合平台。我们致力于为用户提供最全面、最便捷的在线影视观看体验，聚合香蕉视频、红桃视频、91视频等多家优质平台资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，让每一位用户都能在这里找到自己喜欢的视频内容。",
  mission: "让每个人都能轻松享受高品质影视内容",
  vision: "成为华人世界最受欢迎的视频资源聚合平台",
  history: [
    { year: "2020", event: "平台创立", description: "久久视频正式上线，初期聚合3家视频平台资源" },
    { year: "2021", event: "用户破百万", description: "凭借优质内容聚合服务，注册用户突破100万" },
    { year: "2022", event: "品类全覆盖", description: "完成电影、电视剧、综艺、动漫、纪录片全品类布局" },
    { year: "2023", event: "技术升级", description: "全面升级视频播放技术，支持4K超高清画质" },
    { year: "2024", event: "生态扩展", description: "合作平台扩展至30+，内容库突破10万部" },
    { year: "2025", event: "AI智能推荐", description: "上线AI智能推荐系统，个性化内容匹配准确率达95%" },
  ],
  features: [
    { icon: "ri-shield-check-line", title: "正版授权", description: "与多家视频平台建立合作关系，确保内容合法合规" },
    { icon: "ri-speed-up-line", title: "极速播放", description: "自建CDN加速网络，全国多地节点覆盖，播放流畅不卡顿" },
    { icon: "ri-smartphone-line", title: "多端适配", description: "支持电脑、平板、手机等多终端无缝切换观看" },
    { icon: "ri-download-cloud-2-line", title: "海量资源", description: "10万+影视资源库，每日更新，总有你想看的" },
    { icon: "ri-user-star-line", title: "智能推荐", description: "AI算法精准分析你的观影偏好，推荐最合适的内容" },
    { icon: "ri-customer-service-2-line", title: "贴心服务", description: "7x24小时客服在线，随时解决您的观影问题" },
  ],
  testimonials: [
    {
      name: "张先生",
      avatar: "https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20business%20casual%20style%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-001&orientation=squarish",
      content: "久久视频真的太方便了！以前要切换好几个APP找想看的剧，现在一个平台全搞定，推荐功能也很准，强烈推荐！",
      rating: 5,
      date: "2026-07-28"
    },
    {
      name: "李女士",
      avatar: "https://readdy.ai/api/search-image?query=A%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20clean%20white%20background%2C%20casual%20elegant%20style%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-002&orientation=squarish",
      content: "作为追剧党，久久视频是我的必备工具。更新快、画质好，关键是完全免费，身边的朋友都在用。",
      rating: 5,
      date: "2026-07-25"
    },
    {
      name: "王同学",
      avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20student%20portrait%2C%20energetic%20smile%2C%20clean%20white%20background%2C%20casual%20young%20style%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-003&orientation=squarish",
      content: "动漫资源超全！追新番特别方便，画质清晰流畅，还有弹幕功能可以和其他漫友一起讨论，太爱了！",
      rating: 5,
      date: "2026-07-20"
    },
    {
      name: "赵先生",
      avatar: "https://readdy.ai/api/search-image?query=A%20middle%20aged%20Chinese%20man%20portrait%2C%20confident%20smile%2C%20clean%20white%20background%2C%20smart%20casual%20style%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=200&height=200&seq=avatar-004&orientation=squarish",
      content: "纪录片频道质量很高，BBC和Discovery的资源都有。周末最喜欢泡在久久视频上看纪录片，开阔眼界。",
      rating: 4,
      date: "2026-07-18"
    },
  ],
  contact: {
    email: "contact@jiujiu.video",
    phone: "400-888-9999",
    address: "北京市朝阳区望京科技园久久视频大厦",
    wechat: "jiujiushipin",
    qq: "88889999",
  },
  faqs: [
    {
      question: "久久视频需要付费吗？",
      answer: "久久视频完全免费使用。我们通过聚合各平台公开资源，为用户提供便捷的视频导航和播放服务，不向用户收取任何费用。"
    },
    {
      question: "如何找到我想看的视频？",
      answer: "您可以通过首页的分类导航、顶部的搜索框，或者浏览各分类页面来查找您感兴趣的视频内容。我们的AI智能推荐系统也会根据您的观看习惯推荐相关内容。"
    },
    {
      question: "支持哪些设备观看？",
      answer: "久久视频支持电脑端（Windows/Mac）、平板端（iPad/Android平板）和手机端（iOS/Android）观看，数据实时同步，随时随地想看就看。"
    },
    {
      question: "视频画质如何？",
      answer: "我们提供从标清到4K超高清的多档画质选择，您可以根据网络状况和需求自由切换。推荐在WiFi环境下选择高清或超清画质以获得最佳观影体验。"
    },
    {
      question: "新视频更新速度快吗？",
      answer: "我们与各视频平台保持实时同步，热门电影和电视剧通常在上线后24小时内即可在久久视频找到。建议关注我们的更新通知，第一时间获取最新内容。"
    },
  ],
};